"use client";

import { PopoverRoot } from "@faire/slate/private/popover/PopoverRoot";
import React from "react";

import type { TooltipRole } from "./types";
import { getTooltipRole } from "./utils";

type IProps = { role: TooltipRole } & Omit<
  React.ComponentProps<typeof PopoverRoot>,
  "role" | "open" | "onOpenChange"
>;

export const TooltipRoot: React.FC<IProps> = ({ role: roleProp, ...props }) => {
  const role = getTooltipRole(roleProp);

  return <PopoverRoot {...props} role={role} />;
};
